export default __webpack_public_path__ + "static/media/KZ.T.10.2064.bc5a3d5d.svg";